/** Public Firebase web config — keys are safe to ship in the client bundle. */

export interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

const defaults: FirebaseWebConfig = {
  apiKey: 'AIzaSyDnrRrXqSQfnjP5lI_q8XFmrCM3nipZ5Lk',
  authDomain: 'vo2peaks.firebaseapp.com',
  projectId: 'vo2peaks',
  storageBucket: 'vo2peaks.firebasestorage.app',
  messagingSenderId: '432363586188',
  appId: '',
};

function env(key: string): string {
  const value = import.meta.env[key];
  return typeof value === 'string' ? value.trim() : '';
}

export function getFirebaseWebConfig(): FirebaseWebConfig {
  return {
    apiKey: env('VITE_FIREBASE_API_KEY') || defaults.apiKey,
    authDomain: env('VITE_FIREBASE_AUTH_DOMAIN') || defaults.authDomain,
    projectId: env('VITE_FIREBASE_PROJECT_ID') || defaults.projectId,
    storageBucket: env('VITE_FIREBASE_STORAGE_BUCKET') || defaults.storageBucket,
    messagingSenderId: env('VITE_FIREBASE_MESSAGING_SENDER_ID') || defaults.messagingSenderId,
    appId: env('VITE_FIREBASE_APP_ID') || defaults.appId,
  };
}

export function getFirebaseVapidKey(): string {
  return env('VITE_FIREBASE_VAPID_KEY');
}

export function isFirebasePushConfigured(): boolean {
  const cfg = getFirebaseWebConfig();
  return Boolean(cfg.appId && getFirebaseVapidKey());
}
